import axios from "axios";
import { env } from "@/shared/config/env";
import { attachAuthInterceptor } from "./authInterceptor";

const bodycamClient = axios.create({
  baseURL: env.api.bodycam,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(bodycamClient);

export default bodycamClient;
